import React, { useState, useEffect, useRef } from 'react';
import Typography from '@digital-hig/mui/dist/Typography';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import window from 'global/window';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
// eslint-disable-next-line import/no-extraneous-dependencies
import Button from '@mui/material/Button';
// eslint-disable-next-line import/no-extraneous-dependencies
import SvgIcon from '@mui/material/SvgIcon';
import SvgDownload from '@digital-hig/icon/lib/esm/icons/download';
// eslint-disable-next-line import/no-extraneous-dependencies
import TextLink from '@mui/material/Link';
import {
  iconMap,
} from './constants';
import {
  getFilesSizes,
} from './utilities';
import { triggerManualLinkClick } from './analyticsApi';

const EduResDownloads = ({
  downloads, btnLabel, title, analyticsPrefix,
}) => {
  const linkRef = useRef([]);
  const [resourceFileSizes, setResourceFileSizes] = useState(null);

  useEffect(() => {
    if (downloads && downloads.length) {
      getFilesSizes(downloads).then((sizes) => {
        setResourceFileSizes(sizes);
      });
    }
  }, []);

  const handleDownloadAll = () => {
    triggerManualLinkClick({ linkTitle: `${analyticsPrefix}:${btnLabel}` });
    const allDownlowdableLinks = new Set();
    linkRef.current.forEach((link) => allDownlowdableLinks.add(link.querySelector('a')));

    const list = Array.from(allDownlowdableLinks);
    if (list.length) {
      // Download first
      const firstLink = list.shift();
      firstLink.click();
      const downloadInterval = setInterval(() => {
        if (list.length) {
          const link = list.shift();
          link.click();
        } else {
          clearInterval(downloadInterval);
        }
      }, 1500);
    }
  };

  const buildStr = (resource) => {
    let fileNameStr = 'Download';
    const extension = resource.substring(resource.lastIndexOf('.') + 1, resource.length);
    const fileName = resource.substring(resource.lastIndexOf('/') + 1, resource.length);
    if (resourceFileSizes && resourceFileSizes[resource]) {
      fileNameStr = `${window.decodeURIComponent(fileName)} - (${resourceFileSizes[resource]})`;
    } else if (extension) {
      fileNameStr = `${window.decodeURIComponent(fileName)}`;
    }
    const Icon = iconMap[extension] ? iconMap[extension] : iconMap.generic;
    return (
      <>
        <SvgIcon size="medium"><Icon /></SvgIcon>
        {' '}
        <TextLink
          href={resource}
          onClick={() => { triggerManualLinkClick({ linkTitle: `${analyticsPrefix}:${fileNameStr}` }); }}
        >
          {fileNameStr}
        </TextLink>
      </>
    );
  };

  return (
    <RootElement>
      {resourceFileSizes?.length !== 0 && downloads?.length !== 0
          && (
            <Grid xs={12} lg={8} rowSpacing={2} className="download-resource-block">
              <Typography variant="short-copy-small" className="title">{title}</Typography>
              <Grid component="ul" className={`${downloads.length > 3 ? 'two-columns' : ''}`}>
                {downloads?.map((resource) => (
                  <Grid key={resource} component="li">
                    <Typography component="label" variant="body-copy-small" ref={((element) => element && linkRef.current.push(element))}>
                      {buildStr(resource)}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
              {downloads.length > 1
              && (
                <Grid>
                  <Button
                    size="small"
                    startIcon={<SvgIcon fontSize="medium"><SvgDownload /></SvgIcon>}
                    variant="outlined"
                    onClick={handleDownloadAll}
                  >
                    {btnLabel}
                  </Button>
                </Grid>
              )}
            </Grid>
          )}
    </RootElement>
  );
};

const RootElement = styled.div`
    .download-resource-block {
      .title {
        margin: 8px 0 16px 0;
      }
      ul{
        padding: 16px 0 2px 0;
        list-style: none;

        li{
          margin-bottom: 12px;
          label{
            display:flex;
            align-items: center;
          }
          a{
            margin-left: 6px;
            text-decoration: none;
            font-weight: bold;
          }
        }
      }
      ul.two-columns {
        column-count: 2;
      }    
    }
`;

EduResDownloads.propTypes = {
  downloads: PropTypes.arrayOf(),
  title: PropTypes.string.isRequired,
  btnLabel: PropTypes.string.isRequired,
  analyticsPrefix: PropTypes.string,
};

EduResDownloads.defaultProps = {
  downloads: [],
  analyticsPrefix: 'unknown',
};

export default React.memo(EduResDownloads);
